﻿import * as Res from "./res";
import { createElement } from "./_dom";

function createBigSpinner() {
	const spinner = createElement("div", { class: "v3-spinner-container" },
		createElement("div", { class: "v3-spinner-big" },
			createElement("div")),
		createElement("div", { class: "v3-spinner-container__label" }, Res.getString("location.loading")));
	return spinner;
}

function createSmallSpinner(loaderText, extraClass = "v3-view-loader") {
	return createElement("div", { "class": [ "ui-icon-spinner", extraClass ] }, " ", loaderText);
}

export { createBigSpinner, createSmallSpinner };